export enum PublicFormType {
  Public = 0,
  Intranet = 1
}

export const DEFAULT_PUBLIC_FORM_SUBJECT = 'Public Form Submission';

export const PublicFormTypeLabels = {
  [PublicFormType.Public]: 'Public',
  [PublicFormType.Intranet]: 'Requires Sign in'
};
